@if (entityId() === null) {
<div class="p-8 space-y-6 animate-pulse">
  <div class="h-32 bg-slate-200 rounded-xl"></div>
  <div class="h-24 bg-slate-200 rounded-xl"></div>
</div>
} @else if (entityId()) { @if (loadedComponent()) {
<ng-container
  *ngComponentOutlet="loadedComponent(); inputs: dynamicInputs()"
></ng-container>
} @else {
<div class="p-8 space-y-6 animate-pulse">
  <div class="h-32 bg-slate-200 rounded-xl"></div>
  <div class="h-24 bg-slate-200 rounded-xl"></div>
</div>
} }

<!-- loading -->
@else if (loading()) {

<div class="flex flex-col items-center justify-center p-8 gap-3">
  <div
    class="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-blue-500"
  ></div>
  <p class="text-sm font-medium text-slate-500 animate-pulse">Loading...</p>
</div>
}

<!-- fix button -->
@else if (entityId() === undefined) {
<div class="p-8 text-center border-2 border-dashed border-slate-200 rounded-xl">
  <p class="text-slate-500 font-medium">
    Settings configuration not found for this type.
    <button
      class="ml-2 px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium rounded-md transition-colors duration-200"
      (click)="fixElement()"
    >
      Fix now
    </button>
  </p>
</div>
} @else {
<div class="flex flex-col items-center justify-center p-8 gap-3">
  <div
    class="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-blue-500"
  ></div>
  <p class="text-sm font-medium text-slate-500 animate-pulse">Loading...</p>
</div>
}
